import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  public isLoading = new BehaviorSubject<boolean>(false);
  public isLoading$ = this.isLoading.asObservable();

  show() {
    setTimeout(() => {
      this.isLoading.next(true);
    }, 0);
  }

  hide() {
    this.isLoading.next(false);
  }
}
